// extracted by mini-css-extract-plugin
export var responsiveCardContainer = "LatestPosts-module--responsiveCardContainer--kY6on";
export var customCardStyle = "LatestPosts-module--customCardStyle--26Jaw";
export var exploreBlogs = "LatestPosts-module--exploreBlogs--QCbXU";